import { onCleanup, onMount, Show } from "solid-js"
import { createStore } from "solid-js/store"
import { Button } from "@opencode/ui/button"
import { Logo } from "@opencode/ui/logo"
import { Spinner } from "@opencode/ui/spinner"
import { useLanguage } from "@/runtime/i18n/language"
import type { SairAccountContext } from "./account"
import "./gate.css"

export function SairSignInProgress(props: { account: SairAccountContext; workspace?: boolean }) {
  const language = useLanguage()
  const [state, setState] = createStore({ slow: false })
  // CloudApp mounts each waiting stage separately, including after a retry.
  onMount(() => {
    const timer = setTimeout(() => setState("slow", true), 60_000)
    onCleanup(() => clearTimeout(timer))
  })
  return (
    <section
      class="sair-sign-in-content sair-cloud-status"
      data-testid={props.workspace ? "cloud-workspace-progress" : "sair-sign-in-progress"}
    >
      <div class="sair-sign-in-wordmark" role="img" aria-label={language.t("sair.logo")}>
        <Logo />
      </div>
      <div class="sair-sign-in-progress-body">
        <div class="sair-sign-in-progress-title">
          <Spinner />
          <h1>{language.t(props.workspace ? "cloud.workspace.opening" : "sair.web.signingIn")}</h1>
        </div>
        <p role="status">{language.t(props.workspace ? "cloud.workspace.preparing" : "sair.web.verifying")}</p>
        <Button
          variant="neutral"
          class="sair-sign-in-progress-cancel"
          data-waiting={!state.slow}
          aria-hidden={!state.slow}
          aria-label={language.t(props.workspace ? "sair.logout.action" : "sair.signIn.cancel")}
          title={props.workspace ? language.t("cloud.workspace.signOut") : undefined}
          disabled={!state.slow || props.account.state.busy}
          onClick={() => void (props.workspace ? props.account.logout() : props.account.cancel())}
        >
          {language.t(props.workspace ? "sair.logout.action" : "sair.web.cancel")}
        </Button>
      </div>
      <Show when={props.workspace}>
        <div class="sair-workspace-skeleton" aria-hidden="true">
          <span class="sair-workspace-skeleton-heading" />
          <span class="sair-workspace-skeleton-line" />
          <span class="sair-workspace-skeleton-line" />
          <span class="sair-workspace-skeleton-line" />
          <span class="sair-workspace-skeleton-composer" />
        </div>
      </Show>
    </section>
  )
}
